import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/HomePage.vue'),
    },
    {
      path: '/button',
      name: 'Button',
      component: () => import('@/views/ButtonPage.vue'),
    },
    {
      path: '/chatting',
      name: 'Chatting',
      component: () => import('@/views/ChattingPage.vue'),
    },
    {
      path: '/demo',
      name: 'Demo',
      component: () => import('@/views/DemoPage.vue'),
    },
    {
      path: '/pii',
      name: 'Pii',
      component: () => import('@/views/PiiPage.vue'),
    },
    {
      path: '/b/:code',
      name: 'FileBundle',
      component: () => import('@/views/FileBundlePage.vue'),
    },
  ],
})

export default router
